<template>
  <span class="badge badge-pill" :class="classStatus">
    {{ statusName }}
  </span>
</template>

<script>
export default {
  name: "DesignCostStatus",
  props: {
    status: Number
  },
  computed: {
    statusName() {
      switch (this.status) {
        case 0:
          return "Not Used";
        case 1:
          return "Pending payment";
        case 2:
          return "Paid";
        case 3:
          return "Refunded";
        default:
          return "Not Used";
      }
    },
    classStatus() {
      switch (this.status) {
        case 0:
          return 'badge-warning';
        case 1:
          return 'badge-cyan';
        case 2:
          return 'badge-success';
        case 3:
          return 'badge-primary';

        default:
          return 'badge-warning';
      }
    },
  }
}
</script>

<style scoped>

</style>